export default "__VITE_ASSET__CO_RVd2r__"